"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOidcSecure = exports.OidcSecure = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const vanillaOidc_js_1 = require("./vanilla/vanillaOidc.js");
const OidcSecure = ({ children, callbackPath = null, extras = null, configurationName = 'default' }) => {
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    (0, react_1.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(callbackPath, extras);
        }
    }, [configurationName, callbackPath, extras]);
    if (!oidc.tokens) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.OidcSecure = OidcSecure;
const withOidcSecure = (WrappedComponent, callbackPath = null, extras = null, configurationName = 'default') => (props) => {
    return (0, jsx_runtime_1.jsx)(exports.OidcSecure, Object.assign({ callbackPath: callbackPath, extras: extras, configurationName: configurationName }, { children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props)) }));
};
exports.withOidcSecure = withOidcSecure;
//# sourceMappingURL=OidcSecure.js.map